"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ArrowItemWrapper = exports.ArrowItem = exports.getIcon = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _rawButton = _interopRequireDefault(require("@paprika/raw-button"));

var _ArrowRight = _interopRequireDefault(require("@paprika/icon/lib/ArrowRight"));

var _ArrowLeft = _interopRequireDefault(require("@paprika/icon/lib/ArrowLeft"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getIcon = function getIcon(type) {
  var selectedIcon = null;

  if (type === "Left") {
    selectedIcon = _ArrowLeft["default"];
  } else if (type === "Right") {
    selectedIcon = _ArrowRight["default"];
  }

  return (0, _styledComponents["default"])(selectedIcon).withConfig({
    displayName: "ArrowItemstyles",
    componentId: "sc-1jndghx-0"
  })(["", ""], function (_ref) {
    var isDisabled = _ref.isDisabled;
    return (0, _styledComponents.css)(["color:", ";line-height:", ";"], isDisabled ? _tokens["default"].color.blackLighten40 : _tokens["default"].color.black, _tokens["default"].space * 3);
  });
};

exports.getIcon = getIcon;
var ArrowItem = (0, _styledComponents["default"])(_rawButton["default"]).withConfig({
  displayName: "ArrowItemstyles__ArrowItem",
  componentId: "sc-1jndghx-1"
})(["", ""], function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return (0, _styledComponents.css)(["align-items:center;border-radius:", ";box-sizing:border-box;display:flex;", ";height:", ";justify-content:center;line-height:", ";margin-left:", ";margin-right:", ";min-width:", ";padding:0 ", ";position:relative;", ""], _tokens["default"].button.borderRadius, _stylers["default"].fontSize(-1), _stylers["default"].spacer(3), _stylers["default"].spacer(3), _tokens["default"].spaceSm + 1, _tokens["default"].spaceSm, _stylers["default"].spacer(3), _tokens["default"].spaceSm, !isDisabled ? "&:hover {\n      background: ".concat(_tokens["default"].color.blackLighten70, ";\n    ") : "");
});
exports.ArrowItem = ArrowItem;

var ArrowItemWrapper = _styledComponents["default"].span.withConfig({
  displayName: "ArrowItemstyles__ArrowItemWrapper",
  componentId: "sc-1jndghx-2"
})(["border-right:1px solid ", ";margin-right:", ";position:relative;&:last-child{border:none;}"], _tokens["default"].border.color, _tokens["default"].spaceSm);

exports.ArrowItemWrapper = ArrowItemWrapper;
//# sourceMappingURL=ArrowItem.styles.js.map